<template>
  <div class="grupo-familiar responsavel-atendimento" v-loading="loading">
    <div class="beneficiarios">
      <el-button
        v-for="(beneficiario, indexB) in this.listaContatos"
        :key="indexB"
        :style="estiloBotao"
        @click="() => beneficiario.canSelect ? select(beneficiario) : null"
        :class="[!beneficiario.canSelect ? 'card-block' : '']"
        :disabled="!beneficiario.canSelect"
      >
        <div class="container">
          <div class="col1">
            <div class="nome">
              {{ beneficiario.nome }}
            </div>
            <div class="row">
              <div class="texto">
                {{ beneficiario.beneficiarioDados.dadosPessoais.contato.telefoneCelular }}
              </div>
            </div>
          </div>
          <div class="col2">
            <div class="row">
              <i class="material-icons-outlined icon" style="color:#09B531" v-if="beneficiario.canSelect && beneficiario.permissoesApp.canSendPushVoip">
                mobile_friendly
              </i>
              <i class="material-icons-outlined icon" style="color:#999" v-if="!beneficiario.canSelect">
                block
              </i>
              <i
                style="margin-left: 15px"
                :style="estiloIcone"
                class="el-icon-arrow-right"
              />
            </div>
          </div>
        </div>
      </el-button>
    </div>
  </div>
</template>
<script>
import { OmniMeetingResource } from '@/API'
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { mapListaByContrato } from '@/components/GrupoFamiliar/GrupoFamiliarHelpers'

export default {
  name: 'GrupoFamiliarBeneficiario',
  props: {
    idFuncionalidade: {
      type: [Number, String]
    },
    value: {
      type: Object,
      default: () => ({})
    },
    numeroContrato: {
      type: String,
      required: true
    }
  },
  watch: {
    value (newValue) {
      this.beneficiarioSelecionado = newValue
    }
  },
  data () {
    return {
      listaContratoBeneficiarios: [],
      listaContatos: [],
      beneficiarioSelecionado: null,
      loading: true
    }
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo', 'aplicacao', 'textoVinculoContrato']),
    ...mapGetters('Login', ['contratos', 'beneficiarios']),
    ...mapState('Func53', ['paciente']),
    ...mapState('SetupApp', ['apiGrupoFamiliar', 'funcionalidade']),
    estiloBotao () {
      if (!this.estilo.aplicacao) { return '' }
      return {
        'background': `${this.estilo.aplicacao.corPrimariaAplicacao}0d`
      }
    },
    estiloIcone () {
      if (!this.estilo.aplicacao) { return '' }
      return {
        'color': `${this.estilo.aplicacao.corPrimariaAplicacao}`
      }
    },
    visualizaContratosVazios () {
      if (!this.aplicacao.grupoFamiliar) {
        return true
      }

      return this.aplicacao.grupoFamiliar.visualizaContratosVazios
    },
    permiteResponsavelMenorIdade () {
      return this.funcionalidade.parametros.permiteResponsavelMenorIdade
    }
  },
  methods: {
    async init () {
      // Sempre que iniciado o Grupo Familiar deve iniciar com nenhum deles selecionados
      this.beneficiarioSelecionado = null

      let beneficiariosIntegracao = null
      try {
        beneficiariosIntegracao = await this.getGrupoFamiliar()
      } catch (ignored) {}
      this.loading = false

      const contratos = mapListaByContrato(
        beneficiariosIntegracao,
        this.contratos,
        this.beneficiarios,
        this.idFuncionalidade,
        this.visualizaContratosVazios
      )
      const contrato = contratos.find((el, i) => {
        return el.contrato === this.numeroContrato
      })

      const permissoes = await OmniMeetingResource.permissoes()
      const contatosComPermissoes = permissoes.data.find((el, i) => {
        return el.numeroContrato === this.numeroContrato
      })

      this.listaContatos = contrato.data
        .map((beneficiario) => {
          const contatoComPermissao = contatosComPermissoes.beneficiarios.find(
            item => item.chaveUnica === beneficiario.chaveUnica
          )
          if (contatoComPermissao) {
            beneficiario.permissoesApp = contatoComPermissao.permissoesApp
          }

          beneficiario.canSelect = true
          if (
            !this.permiteResponsavelMenorIdade &&
            beneficiario.beneficiarioDados &&
            beneficiario.beneficiarioDados.dadosPessoais &&
            beneficiario.beneficiarioDados.dadosPessoais.dataNascimento
          ) {
            const birthDate = new Date(beneficiario.beneficiarioDados.dadosPessoais.dataNascimento)
            try {
              const age = moment().diff(moment(birthDate), 'years')
              beneficiario.canSelect = (age >= 18)
            } catch {}
          }

          return beneficiario
        })
    },
    async getGrupoFamiliar () {
      if (this.apiGrupoFamiliar.grupoFamiliar) {
        const result = await this.apiGrupoFamiliar.grupoFamiliar({
          payload: {
            idFuncionalidade: this.idFuncionalidade
          },
          handlerErrorIgnore: true
        })

        if (!result.status) {
          return false
        }
        const { contratos } = result.data

        const invalid = contratos.filter(contrato => {
          return !contrato.beneficiarios
        })

        if (invalid.length) {
          return false
        }
        return contratos
      }
      return false
    },
    select (beneficiario) {
      this.$emit('input', beneficiario)
      this.$emit('click', beneficiario)
      this.beneficiarioSelecionado = beneficiario
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped>
.grupo-familiar {
  width: 100%;
  padding: 0;
}

.container {
  width: 100%;
  justify-content: space-between;
  align-items: center;
  display: flex;
  flex-flow: row nowrap;
}

.col1 {
  width: 80%;
  align-items: flex-start;
}

.col2 {
  padding-left: 13px;
}

.row {
  margin-top: 2px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
}

.nome {
  text-transform: none;
  font: normal normal 600 14px/19px Open Sans;
  letter-spacing: 0;
  color: #333333;
}

.texto {
  font: normal normal normal 12px/17px Open Sans;
  letter-spacing: 0;
  color: #555555;
}

.card-block {
  background: #F6F6F6!important;
  cursor: default;
}

.card-block .nome, .card-block .texto {
  color: #888888;
}

.card-block .el-icon-arrow-right {
  color: #888888!important;
}

.responsavel-atendimento {
  .icon {
    font-size: 18px;
  }
}
</style>
